import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { Observable, of } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {

    constructor(private keycloakService: KeycloakService, private router: Router, private authService: AuthService) { }

    canActivate(): Observable<boolean> {
        if (!this.keycloakService.isLoggedIn()) {
            this.router.navigate(['/desktop']);
            return of(false);
        }
        return of(true);
    }

    canActivateGlobalAdmin(): Observable<boolean> {
        if (!this.keycloakService.isLoggedIn() || !this.authService.isGlobalAdmin()) {
            this.router.navigate(['/desktop']);
            return of(false);
        }
        return of(true);
    }
}
